"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M15.5821 11c0 .5514.4336 1 .9685 1s.9686-.4486.9686-1-.4337-1-.9686-1-.9685.4486-.9685 1z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c-1.6186 3.3726-4.7854 6-8.5722 6-3.2198 0-5.8624-1.47-7.6304-2.8391L2 17.118V6.882l3.7974 1.957C7.5654 7.4701 10.208 6 13.4278 6 17.213 6 20.3831 8.627 22 12zm-9.2695-3.972c-2.5667.2067-4.7425 1.5374-6.6928 3.171l-2.0974-1.081v3.764l2.0974-1.081c1.932 1.6182 4.0833 2.9402 6.623 3.165-.561-1.0522-.9592-2.374-.9592-3.966 0-1.38.4084-2.756 1.029-3.972zm2.1682 7.8052c2.0689-.4808 3.7912-2.0106 4.9004-3.8332-1.1055-1.8165-2.82-3.3425-4.8802-3.8285-.7623 1.0791-1.2771 2.4894-1.2771 3.8285 0 1.7024.5855 2.9698 1.2569 3.8332z"
  })];
};

exports.default = _default;